// Otto's ACTIVE-FILTER contract: turn a page's raw filter params (`dashboardFilterParams` shape — the same
// object the dashboard and the Recommendations page both keep) into the `activeFilters` structure every Otto
// path consumes: multi-turn context (buildActiveContext), the cascade for feasibility counts, "remove the …
// filter" grounding, and the "which filters are active?" answer.
//
// SHARED on purpose. Each mount used to build this itself against whatever field list it had at hand, and the
// dashboard's was `dashboardReducer.filterFields` — the BASE set only. Anything assembled on top of it
// (criticality, the priority band, recommendation/building dynamic fields) was therefore INVISIBLE here: it
// could be applied by Otto but never appeared as applied, so a removal couldn't find it and a state answer
// would under-report it. Both mounts now pass the COMPLETE assembled set (useOttoFilterFields.filterFields),
// which also carries the Otto-facing relabels — so labels read exactly as they do in the filter window.
//
// `params` keys are paramKeys; values are option-id arrays, plus the wildcard bag under `filters` and the
// year range. Defensive throughout: an unknown key or a field with no getListKey contributes nothing.
export const buildActiveFilterState = (params, filterFields) => {
    const p = params || {};
    const byParamKey = {};
    (filterFields || []).forEach(f => {
        if (f && f.paramKey) byParamKey[f.paramKey] = f;
    });

    const list = [];
    const wildcards = [];
    Object.keys(p).forEach(key => {
        if (key === "filters" && p.filters && typeof p.filters === "object") {
            Object.keys(p.filters).forEach(wk => {
                const f = byParamKey[wk];
                // `key` lets the removal path match an active wildcard back to its field id (to clear it);
                // `label` is the human name shown in the active-filters summary.
                wildcards.push({ label: f ? f.label : wk, key: f ? f.key || f.paramKey || wk : wk });
            });
            return;
        }
        const f = byParamKey[key];
        if (f && f.getListKey && Array.isArray(p[key]) && p[key].length) {
            list.push({ get_list_field: f.getListKey, label: f.label, values: p[key].map(String) });
        }
    });

    return { list, wildcards, start_year: p.start_year ?? null, end_year: p.end_year ?? null };
};
